// extracted by mini-css-extract-plugin
export var control = "FormCheckboxField-module--control--Djdxr";
export var item = "FormCheckboxField-module--item--f+3jB";
export var itemLabel = "FormCheckboxField-module--itemLabel--dG8gO";
export var list = "FormCheckboxField-module--list--Cu1mB";